import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class AcademyDemoRequestService {

  constructor(private http:HttpClient) { }

  addAcademyDemoRequest(data) {
    return this.http.post(`${API_URL}accademydemorequest`,data);
  }

  updateAcademyDemoRequest(id,data) {
    return this.http.put(`${API_URL}accademydemorequest/${id}`,data);
  }

  getAcademyDemoRequestById(id:string) {
    return this.http.get(`${API_URL}accademydemorequest/${id}`);
  }

  getAcademyDemoRequest(query:string) {
    return this.http.get(`${API_URL}accademydemorequest${query}`);
    console.log("api",API_URL);
  }
}


